import { render, staticRenderFns } from "./LetterSent.vue?vue&type=template&id=b8a5f0e2&scoped=true&"
import script from "./LetterSent.vue?vue&type=script&lang=js&"
export * from "./LetterSent.vue?vue&type=script&lang=js&"
import style0 from "./LetterSent.vue?vue&type=style&index=0&id=b8a5f0e2&prod&lang=scss&"
import style1 from "./LetterSent.vue?vue&type=style&index=1&id=b8a5f0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a5f0e2",
  null
  
)

export default component.exports